import da from './da';
import de from './de';
import en from './en';
import es from './es';
import es419 from './es-419';
import fr from './fr';
import it from './it';
import nb from './nb';
import nl from './nl';
import pl from './pl';
import pt from './pt';
import ptBR from './pt-BR';
import sv from './sv';
import tr from './tr';

export default {
  da,
  de,
  en,
  es,
  fr,
  it,
  nb,
  nl,
  pl,
  pt,
  sv,
  tr,
  'pt-BR': ptBR,
  'es-419': es419,
};
